import React from 'react';
import { Box, Typography } from '@mui/material';
import theme from '../../theme';

const CharacterCounter = ({ currentLength = 0, maxLength, sx = {} }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', ...sx }}>
      <Typography fontSize={14} color={theme.palette.black[1]}>
        {`${currentLength} / ${maxLength}`}
      </Typography>
    </Box>
  );
};

export default CharacterCounter;
